/* su-delight.js (2026-06-13) — site-wide micro-delights. GPU-only (transform/opacity).
   1. Fly-to-cart: any add button sends the product image sailing into the header cart.
   2. Cart icon pop on landing.
   3. Wishlist heart burst.
   Respects prefers-reduced-motion. */
(function () {
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function cartIcon() {
    return document.querySelector('#cart-icon-bubble, .header__icon--cart, a[href*="/cart"] svg') || null;
  }

  function fly(fromImg) {
    var icon = cartIcon();
    if (!icon || !fromImg) return;
    var a = fromImg.getBoundingClientRect();
    var b = icon.getBoundingClientRect();
    if (!a.width || !b.width) return;
    var ghost = fromImg.cloneNode(false);
    var size = Math.min(a.width, 90);
    ghost.style.cssText = 'position:fixed;z-index:9999;pointer-events:none;border-radius:12px;object-fit:cover;'
      + 'left:' + (a.left + a.width / 2 - size / 2) + 'px;top:' + (a.top + a.height / 2 - size / 2) + 'px;'
      + 'width:' + size + 'px;height:' + size + 'px;'
      + 'transition:transform .65s cubic-bezier(.4,.8,.4,1),opacity .65s ease;will-change:transform,opacity;';
    document.body.appendChild(ghost);
    var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
    var dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    requestAnimationFrame(function () {
      ghost.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.12) rotate(20deg)';
      ghost.style.opacity = '0.25';
    });
    setTimeout(function () {
      ghost.remove();
      var target = icon.closest('a, button') || icon;
      target.style.transition = 'transform .18s cubic-bezier(.34,1.56,.64,1)';
      target.style.transform = 'scale(1.25)';
      setTimeout(function () { target.style.transform = 'scale(1)'; }, 190);
    }, 660);
  }

  function burst(el) {
    var r = el.getBoundingClientRect();
    for (var i = 0; i < 6; i++) {
      var p = document.createElement('span');
      var ang = (Math.PI * 2 / 6) * i;
      p.textContent = '♥';
      p.style.cssText = 'position:fixed;z-index:9999;pointer-events:none;font-size:11px;color:#C4321C;'
        + 'left:' + (r.left + r.width / 2) + 'px;top:' + (r.top + r.height / 2) + 'px;'
        + 'transition:transform .5s ease-out,opacity .5s ease-out;will-change:transform,opacity;';
      document.body.appendChild(p);
      (function (p, ang) {
        requestAnimationFrame(function () {
          p.style.transform = 'translate(' + Math.cos(ang) * 26 + 'px,' + Math.sin(ang) * 26 + 'px) scale(.4)';
          p.style.opacity = '0';
        });
        setTimeout(function () { p.remove(); }, 520);
      })(p, ang);
    }
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('.su-card-action--add, .su-quick-add-trigger, .su-pdp__atc-btn, [name="add"]');
    if (add) {
      /* 2026-10-08: a card's quick add opens the cart drawer at the tap (su-quick-view.js), over the header icon this photo
         would fly to, so it stays put. Pairs with sizes only open their picker on this tap. The PDP's own Add keeps it. */
      if (add.classList.contains('su-quick-add-trigger') && document.querySelector('cart-drawer')) return;
      var scope = add.closest('.su-card-wrap, .card, .su-pdp__pairs-card, .su-pdp__grid, section') || document;
      var img = scope.querySelector('.card__media img, .su-pdp__gallery img, img');
      fly(img);
      return;
    }
    var heart = e.target.closest('.su-wishlist-btn, [data-wishlist-toggle]');
    if (heart && !heart.classList.contains('is-active')) burst(heart);
  }, { passive: true });
})();
